import { render, staticRenderFns } from "./ModalInformation.vue?vue&type=template&id=9b5189cc&scoped=true"
import script from "./ModalInformation.vue?vue&type=script&lang=js"
export * from "./ModalInformation.vue?vue&type=script&lang=js"
import style0 from "./ModalInformation.vue?vue&type=style&index=0&id=9b5189cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5189cc",
  null
  
)

export default component.exports